// extracted by mini-css-extract-plugin
export default {"root":"WLRs95AxqoR8sEUQJJn1","h1":"QT6owMS2P_yKtEBL_NWB","menu":"I8gLaOnwhrmuaGfcByQr","placeHolderShimmer":"iOlOcFnrfDQH8WmfS9PO"};